import React from "react";
import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";

export const StickyMobileCTA = () => (
  <div data-testid="sticky-mobile-cta" className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-[#E2E8F0] shadow-lg">
    <div className="grid grid-cols-2">
      <a href="tel:+919370251358" data-testid="sticky-call" className="flex items-center justify-center gap-2 py-3 text-sm font-semibold text-[#273B59] border-r border-[#E2E8F0]">
        <Phone size={16} className="text-[#1088D4]"/> Call Advisor
      </a>
      <Link to="/apply" data-testid="sticky-apply" className="flex items-center justify-center gap-2 py-3 text-sm font-semibold text-white bg-[#1088D4]">
        <FileText size={16}/> Apply Now
      </Link>
    </div>
  </div>
);
